import React from 'react';
import { mentionedIn } from '../mock';

const MentionedIn = () => {
  const doubled = [...mentionedIn, ...mentionedIn];
  return (
    <section className="py-10 border-y border-stone-200 bg-white overflow-hidden">
      <p className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-stone-500 mb-6">
        Mentioned in
      </p>
      <div className="flex gap-14 animate-marquee" style={{ width: 'max-content' }}>
        {doubled.map((name, i) => (
          <span key={i} className="text-[17px] font-semibold text-stone-400 whitespace-nowrap flex-shrink-0" style={{ fontFamily: 'Plus Jakarta Sans, serif' }}>
            {name}
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .animate-marquee { animation: marquee 40s linear infinite; }
      `}</style>
    </section>
  );
};

export default MentionedIn;
